export default __webpack_public_path__ + "assets/images/378f1c4b765b95a74712f5b60af79bf5-per_google_play.svg";